import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
  nameDepartment: Yup.string().required("O campo nome é obrigatório").trim(),
  description: Yup.string().required("O campo nome é obrigatório").trim(),
});
